<template>
	<div>
        <v-row justify="space-between" align="center">
            <v-col>
                <v-select solo hide-details :items="$store.state.main.teams" v-model="$store.state.main.team" label="Team" />
            </v-col>
            <v-col class="d-flex justify-space-around">
                <v-checkbox v-model="$store.state.stats.excludeWinback" label="Ekskl. retention" />
                <v-checkbox v-model="$store.state.stats.excludeInactive" label="Ekskl. inaktive" />
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
                <range-picker :solo="true" storeName="stats" rangeName="range" periodName="period" :presets="presets" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3" v-for="({ header, value, formatter }, index) in totalCards" :key="index">
                <total-card :header="header" :value="value(totals)" :formatter="formatter" :loading="loading" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3" v-for="({ header, value, formatter }, index) in secondaryCards" :key="index">
                <total-card :header="header" :value="value(totals)" :formatter="formatter" :loading="loading" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-tabs>
                        <v-tab to="/stats/agents">Agenturer</v-tab>
                        <v-tab to="/stats/campaigns">Kampagner</v-tab>
                    </v-tabs>
                    <div>
                        <router-view />
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import RangePicker from "@/components/rangePicker"
import TotalCard from '@/components/totalCard'

export default {
	components: {
        RangePicker,
        TotalCard
    },
    data () {
        return {
            presets: [
                "I dag",
                "I går",
                "Denne uge",
                "Sidste uge",
                "Denne måned",
                "Sidste måned",
                "Dette år",
                "Selvvalgt"
            ],
            totalCards: [
                {
                    header: 'Afsluttede',
                    formatter: this.$options.filters.separator,
                    value: totals => totals.count
                },
                {
                    header: 'Salg pr. emne',
                    formatter: this.$options.filters.separator,
                    value: totals => totals.total / totals.count
                },
                {
                    header: 'Bilpleje / Lønforsikring',
                    formatter: this.$options.filters.separator,
                    value: totals => totals.carService
                },
                {
                    header: 'Solgt præmie',
                    formatter: this.$options.filters.separator,
                    value: totals => totals.total
                },
            ],
            secondaryCards: [
                {
                    header: 'Antal salg',
                    value: totals => totals.sales,
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Hitrate',
                    formatter: this.$options.filters.percentage,
                    value: totals => totals.count ? totals.sales / totals.count : 0
                }
            ]
        }
    },
	computed: {
		period() {
			return this.$store.state.stats.period;
        },
        totals() {
            return this.$store.state.stats.totals
        },
        loading () {
            return this.$store.state.stats.loading
        }
    },
    watch: {
        period: function () {
		    this.$store.commit("stats/setRange", this.$store.state.stats.period);
        }
    },
	created() {
		this.$store.commit("stats/setRange", this.$store.state.stats.period);
	}
};
</script>